import { createFileRoute, redirect } from "@tanstack/react-router"

// /settings → first section. Settings is a panel suite, not a landing page.
export const Route = createFileRoute("/$orgSlug/$eventSlug/settings/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$orgSlug/$eventSlug/settings/feature-flags",
      params,
    })
  },
})
